import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AllocationReduceEmployeeAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AllocationReduceEmployee";

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  getList(payload) {
    // URL mặc định

    let url = this.getAPIUrl() + "/employee-allocation-reduce";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy ds tài sản phân trang theo nhân viên đang sử dụng
   * created by ntphong 25/3/2021
   */
  getAssetUsedByEmployeePaging(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-used-employee"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy ds tài sản phân trang theo nhân viên nhận đại diện
   * created by ntphong 25/3/2021
   */
  getAssetRepresentedByEmployeePaging(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-represented-employee"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin nhân viên kèm theo số lượng tài sản
   * created by ntphong 25/3/2021
   */
  getAssetQuantityByEmployee(employeeID) {
    let request = {
      url: [this.getAPIUrl(), "asset-quantity-employee", employeeID].join("/"),
    };

    return httpClient.getAsync(request);
  }
}

export default new AllocationReduceEmployeeAPI();
